export default class CommonUtils {
  /**
   *  lodash isNil method
   * @param value
   */
  static isNil<T = any>(value: T): boolean {
    return value === undefined || value === null
  }
}
